import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.map.js";
export function debounce(func, wait, immediate) {
  var timeout;
  var leadingVal;
  var resolveList = [];
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var context = this;
    return new Promise(function (resolve) {
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        var res = immediate ? leadingVal : func.apply(context, args);
        timeout = null;
        resolveList.map(function (resolveFn) {
          return resolveFn(res);
        });
        resolveList = [];
      }, wait);
      if (callNow) {
        leadingVal = func.apply(context, args);
        resolve(leadingVal);
      } else {
        resolveList.push(resolve);
      }
    });
  };
}